<template>
  <div class="accordion-component">
    <div class="accordion-heading" :aria-expanded="isOpen" @click="toggleAccordion()">
      <slot name="title" />
      <div class="toggle-icon style-1" v-if="useArrows">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.329" height="9.225" viewBox="0 0 16.329 9.225" style="transform: rotate(180deg)" v-if="isOpen">
          <path fill="currentColor" d="M-923.723,1488.191l-7.945-7.945a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l6.884,6.884,6.884-6.884a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061Z" transform="translate(931.887 -1478.966)" />
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="16.329" height="9.225" viewBox="0 0 16.329 9.225" v-else>
          <path fill="currentColor" d="M-923.723,1488.191l-7.945-7.945a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0l6.884,6.884,6.884-6.884a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061Z" transform="translate(931.887 -1478.966)" />
        </svg>
      </div>
      <div class="toggle-icon style-2" v-else>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" v-if="isOpen">
          <g transform="translate(-863 -329)">
            <circle cx="9" cy="9" r="9" transform="translate(863 329)" fill="#1f7ef2"/>
            <path d="M-1972.756,18879.75h-10.35a.75.75,0,0,1-.75-.75.75.75,0,0,1,.75-.75h10.35a.75.75,0,0,1,.75.75A.75.75,0,0,1-1972.756,18879.75Z" transform="translate(2849.931 -18541)" fill="#fff"/>
          </g>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" v-else>
          <g transform="translate(-863 -463)">
            <circle cx="9" cy="9" r="9" transform="translate(863 463)" fill="#1f7ef2"/>
            <path d="M-1972.756,18879.75h-10.35a.75.75,0,0,1-.75-.75.75.75,0,0,1,.75-.75h10.35a.75.75,0,0,1,.75.75A.75.75,0,0,1-1972.756,18879.75Z" transform="translate(2849.931 -18407)" fill="#fff"/>
            <path d="M-1972.756,18879.75h-10.35a.75.75,0,0,1-.75-.75.75.75,0,0,1,.75-.75h10.35a.75.75,0,0,1,.75.75A.75.75,0,0,1-1972.756,18879.75Z" transform="translate(19751 2449.932) rotate(90)" fill="#fff"/>
          </g>
        </svg>
      </div>
    </div>
    <SmoothReflow>
      <div class="accordion-content" v-show="isOpen">
        <slot name="content" />
      </div>
    </SmoothReflow>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.accordion-component {
  .accordion-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      cursor: pointer;
    }

    .toggle-icon {
      width: 24px;
      text-align: center;

      &.style-1 {
        color: $brand-color-1;
      }

      &.style-2 {
        color: $brand-color-2;
      }
    }
  }
}
</style>

<script>
export default {
  name: "Accordion",
  props: {
    forceClose: {
      type: Boolean,
      default: false,
    },
    useArrows: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
  watch: {
    forceClose(value) {
      if (value) {
        this.isOpen = false;
      }
    },
  },
};
</script>